import axiosInstance from "../Instance/axiosInstance";

/**
 * =========================
 * ADMIN APIs
 * =========================
 */

// ✅ Create Terms
export const createTerms = (data: {
  title: string;
  content: string;
  version?: string;
  effectiveDate?: string;
}) => {
  return axiosInstance.post("/admin/terms", data);
};

// ✅ Get All Terms
export const getAllTerms = () => {
  return axiosInstance.get("/admin/terms");
};

// ✅ Get Single Terms
export const getTermsById = (id: number) => {
  return axiosInstance.get(`/admin/terms/${id}`);
};

// ✅ Update Terms
export const updateTerms = (
  id: number,
  data: {
    title?: string;
    content?: string;
    version?: string;
    effectiveDate?: string;
  }
) => {
  return axiosInstance.put(`/admin/terms/${id}`, data);
};

// ✅ Delete Terms
export const deleteTerms = (id: number) => {
  return axiosInstance.delete(`/admin/terms/${id}`);
};

/**
 * =========================
 * USER APIs
 * =========================
 */

// ✅ Get Active Terms (Public)
export const getActiveTerms = () => {
  return axiosInstance.get("/terms/active");
};